import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MuiIconModule } from '../icon';
import { MuiWizardNextDirective } from './wizard-buttons/mui-wizard-next.directive';
import { MuiWizardPreviousDirective } from './wizard-buttons/mui-wizard-previous.directive';
import { MuiWizardStepHeader } from './wizard-step/mui-wizard-step-header.directive';
import { MuiWizardStep } from './wizard-step/mui-wizard-step.component';
import { MuiWizardStepper } from './wizard-stepper/mui-wizard-stepper.component';
import { MuiWizard } from './wizard/mui-wizard.component';

@NgModule({
  declarations: [
    MuiWizardStep,
    MuiWizard,
    MuiWizardNextDirective,
    MuiWizardPreviousDirective,
    MuiWizardStepHeader,
    MuiWizardStepper
  ],
  imports: [
    CommonModule,
    MuiIconModule,
    CdkStepperModule
  ],
  exports: [
    MuiWizard,
    MuiWizardStepper,
    MuiWizardStep,
    MuiWizardStepHeader,
    MuiWizardNextDirective,
    MuiWizardPreviousDirective
  ]
})
export class MuiWizardModule { }
